export default __webpack_public_path__ + "static/media/glass_painted.4b09f2b9.JPG";